module.exports = __webpack_public_path__ + "stylesheets/comments_68e92357d5d39bb9f95968b8603f0390.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/comments.less
// module id = +goU
// module chunks = 154